import React from 'react';
import SecondaryBudget from './SecondaryBudget';

// =============================================================================
// Distribution › Store Replenishment
//
// RDC to own stores: the retailer side of secondary distribution. Same engine
// as Customer Delivery, separate page, and CONFIG-GATED — admin_config
// MOD_4_MOVE / store_replenishment_enabled. An FMCG manufacturer never sees it.
//
// Three things are specific to this side:
//
//   TEMPERATURE STREAM   one store gets ambient, chilled and frozen deliveries
//                        on three different trucks at three frequencies. One
//                        lane per (cluster × stream); blending them buries the
//                        fact that frozen costs ~9x ambient per cage.
//
//   SCHEDULE, NOT ORDER  stores are on a delivery calendar. Volume growth means
//                        fuller cages, not more drops.
//
//   CLUSTER GRAIN        stores live in md_sites, but the budget grain is the
//                        cluster. 2 000 stores x 3 streams x 12 periods is the
//                        trap this whole design exists to avoid.
//
// The output is an internal recharge into store P&L, not a customer
// negotiation — which is why the rollup is by cluster, not by "customer".
// =============================================================================

const StoreReplenishment = () => (
  <SecondaryBudget
    kind="STORE"
    title="Store Replenishment"
    blurb="RDC to own stores, by cluster and temperature stream. Drops come off the delivery calendar; cages come off the store forecast. Growth fills the cages, it does not add drops."
    serveTitle="Cost to Serve — by Cluster & Stream"
    serveLabel="Cluster / Stream"
    siteLabel="Origin Site (RDC)"
    storageKey="secondary-store-replenishment"
  />
);

export default StoreReplenishment;
